import React from 'react';
import { Box, Typography } from '@mui/material';
import NorthIcon from '@mui/icons-material/North';
import { CustomTooltip } from '@components';

export type ProgressData = {
  name: string;
  value: number;
  percentageChange: number;
  weekAdSharePercent: number;
};

type ProgressBarProps = {
  progressData: ProgressData[];
  textColor?: string;
  showPercentageChange?: boolean;
  barColor?: string;
  subTextTooltip?: string;
};
const SingleProgressBar: React.FC<ProgressBarProps> = ({
  progressData,
  textColor,
  showPercentageChange = false,
  barColor,
  subTextTooltip = 'Wow % change in index for this country, platform or channel',
}) => {
  return (
    <Box width="100%">
      <Box display="flex" height={8} borderRadius={5} overflow="hidden" mb={1} gap="0.125rem">
        <Box flex={Math.abs(progressData[0].value)} bgcolor={barColor} borderRadius={5} />
        <Box flex={100 - Math.abs(progressData[0].value)} bgcolor="#FFFFFF" />
      </Box>
      <Box display="flex" flexWrap="wrap">
        {progressData.map((data, index) => (
          <Typography
            key={index}
            variant="body2"
            flex={data.value < 1 ? 1 : data.value}
            sx={{
              color: textColor,
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 500,
              fontSize: '0.875rem',
              lineHeight: '1rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: '1',
              WebkitBoxOrient: 'vertical',
            }}
          >
            {data.weekAdSharePercent >= 10
              ? `${data.weekAdSharePercent.toFixed(0)}% ${data.name} `
              : `${Math.abs(data.weekAdSharePercent).toFixed(1)}% ${data.name} `}
            {showPercentageChange && (
              <span>
                &#x2022;{' '}
                <CustomTooltip
                  customStyle={{
                    '& .MuiTooltip-tooltip': {
                      borderRadius: '0.75rem',
                      padding: '8px',
                      bgcolor: '#FFF',
                      backdropFilter: 'blur(5px)',
                      border: '1px solid #737F86',
                      position: 'relative',
                      width: '200px',
                    },
                  }}
                  content={
                    <>
                      <div
                        style={{
                          fontFamily: 'Manrope, sans-serif',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          lineHeight: '1.25rem',
                          color: '#162936',
                        }}
                      >
                        <p>{subTextTooltip}</p>
                      </div>
                    </>
                  }
                >
                  <span
                    style={{
                      color: data.percentageChange > 0 ? '#5E8700' : '#FF8C00',
                      paddingLeft: 2,
                      fontFamily: 'Manrope, sans-serif',
                      fontSize: '0.875rem',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    {Math.abs(data.percentageChange) >= 10
                      ? `${Math.abs(data.percentageChange).toFixed(0)}%`
                      : `${Math.abs(data.percentageChange).toFixed(1)}%`}
                    <NorthIcon
                      sx={{
                        fontSize: '0.875rem',
                        transform: data.percentageChange > 0 ? 'rotate(0deg)' : 'rotate(180deg)',
                      }}
                    />
                  </span>
                </CustomTooltip>
              </span>
            )}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default SingleProgressBar;
